export const config = {
  AUTH_URL: 'https://backend.pertento.ai/api/auth',
  API_URL: 'https://backend.pertento.ai/api',
  GAN_URL: 'https://backend.pertento.ai/api/gan',
  STATISTICS_URL: 'https://backend.pertento.ai/api/statistics',
  FILES_URL: 'https://backend.pertento.ai/api/files',
  WS_URL: '',
  EXPERIMENTS_URL: '',
  TRACKING_URL: 'https://tracking.pertento.ai',
  BUILD_ENV: 'production',
  ENV: 'production',
  GOOGLE_AUTH_CLIENT_ID: '306475690020-b6j9ml8puphfi8261g7jv3hgsc1vc3l7.apps.googleusercontent.com',
};
